import React from 'react';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Investissez ensemble, grandissez ensemble</h1>
        <p>
          La première plateforme coopérative d'investissement en Haïti.
          Rejoignez une communauté qui construit l'avenir financier du pays.
        </p>
        <button className="cta-button">Commencer maintenant</button>
      </div>
    </section>
  );
}

export default Hero;
